import React from 'react';
import PropTypes from 'prop-types';

import { colours } from './../helpers';
import DoughnutChartComponent from './DoughnutChartComponent';

const getValues = (value, max) => {
  const remaining = max - value;
  return [
    value,
    remaining + value > 0 ? remaining : 1
  ];
};

const GaugeComponent = ({
  value,
  max,
  title
}) => (
  <DoughnutChartComponent
    title={title}
    subtitle={`${value} / ${max}`}
    height={300}
    data={getValues(value, max)}
    slices={[
      {
        label: 'Completed',
        colour: colours.colours.blue
      },
      {
        label: 'Remaining',
        colour: colours.colours.grey
      }
    ]}
  />
);

GaugeComponent.propTypes = {
  value: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired
};

export default GaugeComponent;


// WEBPACK FOOTER //
// src/Components/GaugeComponent.jsx